import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useAudioPlayer from '../hooks/useAudioPlayer';
import { items } from '../MainList/items';
import HighlightedParagraph from './HighlightedParagraph';
import { getParticle } from './meta';
import {
    AudioPlayer,
    Container,
    Contents,
    Header,
    HeaderContents,
    ImageContainer,
    InfoContainer,
    Keywords,
    Navigator,
    Progress,
    ProgressBarWrapper,
    ProjectImage,
    Subscribe,
    SubscribeContainer,
    SubTitle,
    Title,
    Transcript
} from './styles';

const Record: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const item = items.find((item) => item.key === id);

    const { audioRef, currentTime, currentGroup, seekTo, isEnded } = useAudioPlayer(
        item?.audioUrl || '',
        item?.transcript || [],
        () => navigate('/')
    );

    if (!item) return <></>;

    const progressPercentage = isEnded
        ? 100 : audioRef.current?.duration
            ? (currentTime / audioRef.current.duration) * 100 : 0;

    const handleProgressClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!audioRef.current?.duration) return;

        const progressBar = event.currentTarget.getBoundingClientRect();
        const clickX = event.clientX - progressBar.left;
        const progressRatio = clickX / progressBar.width;
        const seekTime = progressRatio * audioRef.current.duration;

        seekTo(seekTime);
    };


    const mergedTranscript = item.transcript[currentGroup].map((para, index) => (
        <HighlightedParagraph
            key={index}
            paragraph={para}
            currentTime={currentTime}
            highlightColor={item.highlightColor}
        />
    ));

    return (
        <Container isplaying={(!audioRef.current?.paused).toString()}>
            <Header>
                <HeaderContents className='navigate' onClick={() => window.history.back()}>
                    <img src='/icons/arrow_left.svg' />
                    목록으로 돌아가기
                </HeaderContents>
                <HeaderContents>
                    &lt;{item.audioTitle}&gt;{getParticle(item.audioTitle)} 스티비로 만듭니다.
                </HeaderContents>
            </Header>
            <ProgressBarWrapper onClick={handleProgressClick}>
                <Progress style={{ width: `${progressPercentage}%` }} />
            </ProgressBarWrapper>
            <InfoContainer>
                <Contents>
                    <Title>{item.audioTitle}</Title>
                    <Keywords>
                        {item.keywords.map((keyword, index) => (
                            <span key={index}>{keyword}</span>
                        ))}
                    </Keywords>
                    <SubTitle>{item.narrator}</SubTitle>
                </Contents>
                {item.qrUrl && (
                    <Subscribe>
                        <img src={item.qrUrl} />
                        <div>구독하기</div>
                    </Subscribe>
                )}
            </InfoContainer>
            <AudioPlayer ref={audioRef} controls>
                <source src={item.audioUrl} type="audio/mp3" />
            </AudioPlayer>
            {audioRef.current?.paused ? (
                <SubscribeContainer>
                    <Transcript className='subscribe'>
                        {item.qrUrl && (
                            <>
                                더 알아보고 싶으신가요?<br />
                                QR코드를 스캔해 구독해 보세요.
                            </>
                        )}
                        <Navigator onClick={() => navigate('/')}>
                            <img src='/icons/arrow_left.svg' />
                            목록으로 돌아가기
                        </Navigator>
                    </Transcript>
                    <ImageContainer style={{ background: item.imageBackground }}>
                        <ProjectImage
                            style={{ width: 760, height: 710, position: 'absolute', bottom: 0 }} src={item.endingImageURL} isplaying={"false"} />
                    </ImageContainer>
                </SubscribeContainer>
            ) : (
                <>
                    <Transcript>
                        <p>{mergedTranscript}</p>
                    </Transcript>
                    <ImageContainer style={{ background: item.imageBackground }}>
                        <ProjectImage src={item.imageURL} isplaying={(!audioRef.current?.paused).toString()} />
                    </ImageContainer>
                </>
            )}
        </Container>
    );
};

export default Record;
